module.exports = __webpack_public_path__ + "static/img/platform.0574063d.png";